import React, { useState } from 'react';
import './WelcomePanel.css';
import CarIcon from './评logo_50x50.ico';

const WelcomePanel = ({ onStartChat }) => {
  const [inputText, setInputText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [activeCategory, setActiveCategory] = useState(null);
  const [selectedTags, setSelectedTags] = useState({
    price: null,
    style: null,
    energy: null
  });

  // 分类问题数据
  const questionsByCategory = {
    "车型对比": [
      "理想L6",
      "小米su7",
      "问界M9 vs 理想L9",
      "20万以内最好的燃油车",
      "15万全款新能源车，首付低于5万",
      "推荐家用7座车"
    ],
  };

  // 标签数据
  const featureTags = [
    { name: "10w以下", icon: "¥", type: "price" },
    { name: "10-15w", icon: "¥", type: "price" },
    { name: "20-30w", icon: "¥", type: "price" },
    { name: "30-50w", icon: "¥", type: "price" },
    { name: "50w以上", icon: "¥", type: "price" }
  ];
  
  const styleTags = [
    { name: "轿车", icon: "🚗", type: "style" },
    { name: "SUV", icon: "🚙", type: "style" },
    { name: "MPV", icon: "🚐", type: "style" },
  ];
  
  const energyTags = [
    { name: "纯电", icon: "⚡", type: "energy" },
    { name: "汽油", icon: "⛽", type: "energy" },
    { name: "插电混动", icon: "🔌⛽", type: "energy" },
    { name: "增程", icon: "⛽⚡", type: "energy" },
    { name: "油电混合", icon: "⛽🔋", type: "energy" },
    { name: "柴油", icon: "⛽", type: "energy" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputText.trim() || isLoading) return;
    
    setIsLoading(true);
    try {
      await onStartChat(inputText.trim());
      setInputText('');
      // setActiveCategory(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePresetQuestionClick = (question) => {
    setInputText(question);
    onStartChat(question);
  };

  const handleTagClick = (tagName, tagType) => {
    setSelectedTags(prev => {
      // 更新选中状态
      const newTags = {
        ...prev,
        [tagType]: prev[tagType] === tagName ? null : tagName
      };
      
      // 拼接选中的标签
      const selectedText = [
        newTags.price,
        newTags.style,
        newTags.energy
      ].filter(Boolean).join(' ');
      
      // 更新输入框
      setInputText(selectedText);
      
      return newTags;
    });
  };

  const isTagActive = (tagName, tagType) => {
    return selectedTags[tagType] === tagName;
  };

  return (
    <div className="welcome-page car-theme">
      <div className="welcome-container">
        <div className="welcome-content">
          {/* 可滚动内容区域 */}
          <div className="scrollable-content">
            <div className="welcome-header">
              <div className="title-with-icon">
                <img src={CarIcon} alt="汽车图标" className="header-icon" />
                <h1>汇评汽车</h1>
              </div>
              <p className="welcome-subtitle">您的智能汽车顾问，解答购车、用车、养车全流程问题</p>
            </div>
            <div className="welcome-actions">
              {/* 动态问题区域 */}
              <div className="preset-questions-section">
                <p className="section-title">试试这样问我</p>
                <div className="question-list">
                  {Object.values(questionsByCategory)
                    .flat()
                    .slice(0, 6)
                    .map((question, index) => (
                      <div 
                        key={index} 
                        className="question-item"
                        onClick={() => handlePresetQuestionClick(question)}
                      >
                        {question}
                      </div>
                    ))}
                </div>
              </div>
              {/* 价格区间标签 */}
              <p className="section-title">或者，选择你的条件</p>
              <div className="feature-tags-section">
                {/* <p className="section-title">价格区间：</p> */}
                <div className="feature-tags">
                  {featureTags.map((tag, index) => (
                    <div 
                      key={index}
                      className={`tag-item ${isTagActive(tag.name, tag.type) ? 'active' : ''}`}
                      onClick={() => handleTagClick(tag.name, tag.type)}
                    >
                      <span className="tag-icon">{tag.icon}</span>
                      <span>{tag.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 车型标签 */}
              <div className="feature-tags-section">
                {/* <p className="section-title">车型：</p> */}
                <div className="feature-tags">
                  {styleTags.map((tag, index) => (
                    <div 
                      key={index}
                      className={`tag-item ${isTagActive(tag.name, tag.type) ? 'active' : ''}`}
                      onClick={() => handleTagClick(tag.name, tag.type)}
                    >
                      <span className="tag-icon">{tag.icon}</span>
                      <span>{tag.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 能源类型标签 */}
              <div className="feature-tags-section">
                {/* <p className="section-title">能源类型：</p> */}
                <div className="feature-tags">
                  {energyTags.map((tag, index) => (
                    <div 
                      key={index}
                      className={`tag-item ${isTagActive(tag.name, tag.type) ? 'active' : ''}`}
                      onClick={() => handleTagClick(tag.name, tag.type)}
                    >
                      <span className="tag-icon">{tag.icon}</span>
                      <span>{tag.name}</span>
                    </div>
                  ))}
                </div>
              </div>


            </div>
          </div>
          {/* 固定在底部的区域 */}
          <div className="fixed-bottom-section">
            <form onSubmit={handleSubmit} className="welcome-input-form">
              <div className="welcome-input-wrapper">
                <textarea
                  value={inputText}
                  onChange={(e) => setInputText(e.target.value)}
                  placeholder="请输入您的问题..."
                  className="welcome-input"
                  disabled={isLoading}
                  rows={1}
                  autoFocus
                />
                <button 
                  type="submit" 
                  className="send-button"
                  disabled={isLoading || !inputText.trim()}
                >
                  {isLoading ? (
                    <span className="loading-dots">···</span>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </button>
              </div>
            </form>
            {/* 页脚 - 调整到主内容容器外 */}
            <div className="footer-info">
              <div className="footer-content">
                <div className="copyright">© 2025 上海汇评信息科技有限公司 版权所有</div>
                <div className="icp-license">
                  <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                    沪ICP备13047769号-1 
                  </a>&nbsp;&nbsp;
                  <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502403531" rel="noreferrer" target="_blank">
                    沪公网安备31011502403531号
                  </a>
                </div>
              </div>
            </div>           
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomePanel;